import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function WaitlistCount({
  sourcePrefix,
  threshold = 50,
  firstCircleCopy = "Be among the first to step inside — the first quiet circle.",
  testId = "waitlist-count",
  className = "",
}) {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let active = true;
    api
      .get("/subscribers/count", {
        params: sourcePrefix ? { source_prefix: sourcePrefix } : {},
      })
      .then((res) => {
        if (active) setCount(res.data?.count ?? 0);
      })
      .catch(() => {
        if (active) setCount(0);
      });
    return () => {
      active = false;
    };
  }, [sourcePrefix]);

  if (count === null || count < threshold) {
    return (
      <p
        data-testid={testId}
        className={`font-body text-xs text-[#F4F1EC]/55 leading-relaxed tracking-wide ${className}`}
      >
        {firstCircleCopy}
      </p>
    );
  }

  const rounded = Math.floor(count / 10) * 10;
  return (
    <p
      data-testid={testId}
      className={`font-body text-xs text-[#F4F1EC]/70 leading-relaxed tracking-wide ${className}`}
    >
      <span className="text-[#FFB7C6]">●</span>{" "}
      Join <span className="text-[#F4F1EC] font-medium">{rounded}+</span> artists
      already on the WYNN list.
    </p>
  );
}
